__turbopack_context__.v({
  "separator": "UserMenu-module__tHobyW__separator",
  "userMenuContainer": "UserMenu-module__tHobyW__userMenuContainer",
});
